import React from "react";
import "./AlertToast.css";

const AlertToast = ({ message, type = "success", onClose }) => {
  return (
    <div className={`alert-toast ${type}`}>
      {message}
      <button className="close-btn" onClick={onClose}>✖</button>
    </div>
  );
};

export default AlertToast;